import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CampaignDetailsAPI from '../../api/campaignDetails';

const defaultMeta = () => ({
  total: 0,
  delivered: 0,
  read: 0,
  replied: 0,
  page: 1,
  per_page: 25,
});

export const state = {
  records: [],
  meta: defaultMeta(),
  uiFlags: {
    isFetching: false,
    isTagging: false,
    isResending: false,
    isExporting: false,
  },
};

export const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }, { campaignId, params }) {
    commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isFetching: true });
    try {
      const response = await CampaignDetailsAPI.index({
        campaignId,
        params,
      });
      commit(types.SET_CAMPAIGN_DETAILS, response.data.data);
      commit(
        types.SET_CAMPAIGN_DETAILS_META,
        response.data.meta || defaultMeta()
      );
      return response;
    } finally {
      commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isFetching: false });
    }
  },
  async bulkTag({ commit }, { campaignId, payload }) {
    commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isTagging: true });
    try {
      await CampaignDetailsAPI.bulkTag({ campaignId, payload });
    } finally {
      commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isTagging: false });
    }
  },
  async bulkResend({ commit }, { campaignId, payload }) {
    commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isResending: true });
    try {
      await CampaignDetailsAPI.bulkResend({ campaignId, payload });
    } finally {
      commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isResending: false });
    }
  },
  async export({ commit }, { campaignId, params }) {
    commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isExporting: true });
    try {
      const response = await CampaignDetailsAPI.export({
        campaignId,
        params,
      });
      return response;
    } finally {
      commit(types.SET_CAMPAIGN_DETAILS_UI_FLAG, { isExporting: false });
    }
  },
  updateRecord({ commit }, record) {
    commit(types.UPDATE_CAMPAIGN_DETAIL, record);
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_DETAILS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CAMPAIGN_DETAILS]: MutationHelpers.set,
  [types.SET_CAMPAIGN_DETAILS_META](_state, data) {
    _state.meta = {
      ..._state.meta,
      ...data,
    };
  },
  [types.RESET_CAMPAIGN_DETAILS_STATS](_state, detailIds) {
    const idsToReset = new Set(detailIds);
    _state.records = _state.records.map(record => {
      if (idsToReset.has(record.id)) {
        return {
          ...record,
          delivery_status: 'pending',
          read_status: 'unread',
          reply_status: 'awaiting_reply',
          error_code: null,
          error_message: null,
          sent_at: null,
          delivered_at: null,
          read_at: null,
          replied_at: null,
        };
      }
      return record;
    });
  },
  [types.UPDATE_CAMPAIGN_DETAIL](_state, record) {
    const index = _state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      _state.records.splice(index, 1, { ..._state.records[index], ...record });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
